import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { DEFAULT_DESCRIPTION, DEFAULT_TITLE, updateLanguageAlternates, updatePageMetadata } from '../../metadata';
import { routesConfig } from '../../routes';
import { LANGUAGE_PARAM, useTranslation } from '../../i18n/LanguageProvider';

export default function RouteMetadata() {
  const location = useLocation();
  const { t, language } = useTranslation();

  // Navigating with the router drops the query string, so the language is re-stamped on every
  // location change: any page can then be copied from the address bar and shared as it is read.
  useEffect(() => {
    const url = new URL(window.location.href);
    if (url.searchParams.get(LANGUAGE_PARAM) !== language) {
      url.searchParams.set(LANGUAGE_PARAM, language);
      window.history.replaceState(window.history.state, '', url);
    }
  }, [location.pathname, location.search, language]);

  useEffect(() => {
    const current = routesConfig.find(({ path, translationKey }) => translationKey && path !== '/' && (
      location.pathname === path || location.pathname.startsWith(`${path}/`)
    ));

    const routeKey = current?.translationKey;
    const title = routeKey ? t(`nav.${routeKey}`) : null;
    const description = routeKey ? t(`metadata.pages.${routeKey}`) : null;

    updatePageMetadata({
      title: title ? `${title} | Frederico Schardong, PhD` : DEFAULT_TITLE,
      description: description || t('metadata.defaultDescription') || DEFAULT_DESCRIPTION,
      path: location.pathname,
      language,
    });
    updateLanguageAlternates(location.pathname, language);
  }, [location.pathname, language, t]);

  return null;
}
